// Central API base URL for the backend server.
// Override in production via REACT_APP_API_BASE.
export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8080';

export const apiUrl = (path) => `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;

/**
 * Wake the API as soon as the site loads.
 *
 * The backend sleeps after a period of inactivity and takes ~30-60s to start.
 * Pinging it on first paint means it is usually awake by the time someone opens
 * a category or reaches checkout, instead of them waiting on a cold start.
 * Fire-and-forget: failures are irrelevant, the pages all have fallbacks.
 */
let warmed = false;
export function warmUpApi() {
  if (warmed || typeof window === 'undefined') return;
  warmed = true;
  fetch(apiUrl('/'), { method: 'GET', cache: 'no-store' }).catch(() => {});
}

/* --------------------------- Admin auth helpers --------------------------- */
const TOKEN_KEY = 'adminToken';

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearAdminAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem('admin');
};

// Send the admin back to the login screen (used when a token is missing/expired).
const redirectToLogin = () => {
  clearAdminAuth();
  if (window.location.pathname !== '/admin/login') {
    window.location.assign('/admin/login');
  }
};

// Drop-in replacement for `fetch` on authenticated admin endpoints.
// Injects the Bearer token and, on 401/403, clears the session and redirects.
export const adminFetch = async (url, options = {}) => {
  const token = getAdminToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(url, { ...options, headers });
  if (res.status === 401 || res.status === 403) {
    redirectToLogin();
  }
  return res;
};
